<template>
  <div>
    <label for="input__mc-lang" class="h5 font-weight-bold mb-4">Original language</label>
    <b-form-group id="input__radio-mc-lang" class="mb-0" :disabled="disabled">
      <b-form-radio
        v-for="(lang, key) in langs"
        :key="`input__radio-mc-lang-${key}`"
        v-model="selectedLanguage"
        name="mc-language"
        :value="key"
        class="mb-4"
      >
        <h5>{{ lang.name }}</h5>
      </b-form-radio>
    </b-form-group>
  </div>
</template>

<script>
import { ORIGINAL_LANGUAGE } from '@/constants';

export default {
  model: {
    prop: 'modelValue',
    event: 'change'
  },

  props: {
    modelValue: {
      type: Object,
      default: () => ({
        original_lang: null
      })
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      langs: {
        [ORIGINAL_LANGUAGE.THAI]: {
          name: 'Thai only'
        },
        [ORIGINAL_LANGUAGE.ENGLISH]: {
          name: 'English only'
        }
      }
    };
  },
  computed: {
    selectedLanguage: {
      get() {
        return this.modelValue.original_lang;
      },

      set(original_lang) {
        this.$emit('change', { original_lang });
      }
    }
  }
};
</script>
